import { Component, OnInit, Input, Output } from '@angular/core';

import { PopoverController } from '@ionic/angular';

import { ChatService } from 'src/app/services/chat.service';

@Component({
  selector: 'app-municipio-popover',
  templateUrl: './municipio-popover.component.html',
  styleUrls: ['./municipio-popover.component.scss'],
})
export class MunicipioPopoverComponent implements OnInit {

  @Input() estado;
  @Input() id;
  @Input() rol;
  @Input() token;
  @Input() urlBack;

  @Output() option;

  municipios: any;

  constructor(
    private popoverController: PopoverController,
    private chatService: ChatService) { }

  ngOnInit() {
    this.getMunicipios();
  }

  getMunicipios() {
    this.chatService.consultarMunicipio(this.estado, this.id, this.rol, this.token, this.urlBack).subscribe((data: any) => {
      console.log('Datos recibidos de la API:', data);
      if (Array.isArray(data.municipios)) {
        const uniqueNames = new Set<string>();
        this.municipios = data.municipios
          .filter((item: any) => {
            if (!uniqueNames.has(item.municipio)) {
              uniqueNames.add(item.municipio);
              return true;
            }
            return false;
          })
          .map((item: any) => {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const data = { id: item.id, nombre: item.municipio };
            return data;
          })
          .sort((a, b) => a.nombre.localeCompare(b.nombre));

        console.log('Municipios después de filtrar duplicados y ordenar:', this.municipios);
      } else {
        console.error('La respuesta no contiene un arreglo llamado "municipios":', data);
      }
    }, (error) => {
      console.error('Error al consultar los municipios:', error);
    }
    );
  }

  getOption(municipio) {
    console.log('Opción elegida(lado del hijo):', municipio.nombre);
    this.option = municipio.nombre;
    this.popoverController.dismiss(this.option);
  }

  closePopover() {
    this.popoverController.dismiss();
  }

}
